import React from 'react';
import { Link } from 'react-router-dom';

export type ProfileTab = 'basic-info' | 'notifications' | 'security';

type Props = {
  activeItem: ProfileTab;
};

export const Navigation = ({ activeItem }: Props) => {
  return (
    <div className="col max-250 settings-inner-left-menu">
      <Link
        to="/settings/profile/basic-info"
        className={
          activeItem === 'basic-info' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Basic Info
      </Link>
      <Link
        to="/settings/profile/notifications"
        className={
          activeItem === 'notifications'
            ? 'active btn darkGray w100 mb-1 mx-0 px-1'
            : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Notifications
      </Link>
      <Link
        to="/settings/profile/security"
        className={
          activeItem === 'security' ? 'active btn darkGray w100 mb-1 mx-0 px-1' : 'btn darkGray w100 mb-1 mx-0 px-1'
        }
      >
        Security
      </Link>
    </div>
  );
};
